import { alertComponentProps } from '../../utils/component';
import { AlertProps } from './alert.types';

export const alertProps = (props: AlertProps): string => {
  const { color = 'primary' } = props;

  const defaultProps =
    alertComponentProps[color] ?? alertComponentProps['primary'];

  return `${defaultProps}`;
};
